import ax, { type AxiosError } from 'axios';
import axios from 'axios-observable';
import { captureError } from 'infra/monitoring/monitoring.utils';
import { handleResponseError } from '@protector/api-client/http-client/errors/error-handler';
import { handleRequest } from '@protector/api-client/http-client/interceptors/request.interceptor';

interface CustomWindow extends Window {
  axios: typeof axios;
}

ax.interceptors.request.use(handleRequest, (err: AxiosError) => {
  captureError(err, {
    url: err?.config?.url,
    method: err?.config?.method,
    status: err?.response?.status,
    data: err?.response?.data as Record<string, string> | string,
    errorType: 'AxiosError',
    domain: 'AxiosInterceptor'
  });
  return Promise.reject(new Error(err.message ?? 'Request interceptor error'));
});

axios.interceptors.request.use(handleRequest, (err: AxiosError) => {
  captureError(err, {
    url: err?.config?.url,
    method: err?.config?.method,
    status: err?.response?.status,
    data: err?.response?.data as Record<string, string> | string,
    errorType: 'AxiosError',
    domain: 'AxiosInterceptor'
  });
  return Promise.reject(new Error(err.message ?? 'Request interceptor error'));
});

const handleGlobalResponseError = (error: AxiosError) => {
  (error as AxiosError & { __globalInterceptorProcessed?: boolean }).__globalInterceptorProcessed = true;
  return handleResponseError(error);
};

axios.interceptors.response.use(undefined, handleGlobalResponseError);
ax.interceptors.response.use(undefined, handleGlobalResponseError);

(window as unknown as CustomWindow).axios = axios;
